import { debounce } from "lodash";
import { useCallback, useState } from "react";
import { fetchDropDownData } from "../fetchDropDownData";
import { ItemType } from "../../models/ItemTypes";

// Custom hook to manage dropdown fetching
export const ItemListUtils = () => {
    const [modelOptions, setModelOptions] = useState<any[]>([]);
    const [categoryOptions, setCategoryOptions] = useState<any[]>([]);
    const [uomOptions, setUomOptions] = useState<any[]>([]);

    // 🔹 Fetch Models
    const fetchModels = useCallback(
        debounce((inputValue: string) => {
            fetchDropDownData({
                endpoint: "/itemmodels",
                searchKey: "name",
                searchTerm: inputValue,
                labelKey: "name",
                valueKey: "_id",
            }).then(setModelOptions);
        }, 500),
        []
    );

    // 🔹 Fetch Categories
    const fetchCategories = useCallback(
        debounce((inputValue: string) => {
            fetchDropDownData({
                endpoint: "/itemcategorys",
                searchKey: "name",
                searchTerm: inputValue,
                labelKey: "name",
                valueKey: "_id",
            }).then(setCategoryOptions);
        }, 500),
        []
    );

    // 🔹 Fetch UOMs
    const fetchUoms = useCallback(
        debounce((inputValue: string) => {
            fetchDropDownData({
                endpoint: "/uoms",
                searchKey: "name",
                searchTerm: inputValue,
                labelKey: "name",
                valueKey: "_id",
            }).then(setUomOptions);
        }, 500),
        []
    );

    return { 
        modelOptions, 
        categoryOptions, 
        uomOptions, 
        fetchModels, 
        fetchCategories, 
        fetchUoms, 
        setModelOptions, 
        setCategoryOptions, 
        setUomOptions, 
    };
};
